import { from, Observable } from "rxjs";
import { apiClient } from "./api";
import { ENDPOINTS } from "@/settings/api-settings";
import { map } from "rxjs/operators";
import { ProcExecFiltrosParmDTO } from "@/interfaces/async-process";
import { ResultPagDTO } from "@/interfaces/base-dto";

export function listAsyncProcess(parm: ProcExecFiltrosParmDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.ASYNC_PROCESS, parm)).pipe(
    map((r: any) => r.data),
  );
}